import { AddressPrediction, AddressComponent, PostalCodeResult } from '../../../model';
import type { Country } from '../../../constants/country/country';
import type { Currency } from '../../../constants/currency/currency';

export type GeoLocationNull = '-';

export type GetGeoLocationRequest = {
  ip?: string;
};

export type GetGeoLocationResponse = {
  countryCode: Country | GeoLocationNull;
  country: string | GeoLocationNull;
  region: string | GeoLocationNull;
  city: string | GeoLocationNull;
  zipCode: string | GeoLocationNull;
  timeZone: string | GeoLocationNull;
  currency: Currency | GeoLocationNull;
};

export type SearchAddressRequest = {
  input: string;
  countryCode?: string;
};

export type SearchAddressResponse = {
  predictions: AddressPrediction[];
  status: string;
};

export type GetAddressDetailsRequest = {
  placeId: string;
};

export type GetAddressDetailsResponse = {
  formattedAddress: string;
  addressComponents: AddressComponent[];
  postalCode?: string;
  countryCode?: string;
  city?: string;
  state?: string;
  status: string;
};

export interface GetAddressDetailsParams {
  placeId: string;
}

export interface GetPostalCodeRequest {
  postalCode: string;
  countryCode?: string;
}
export interface GetPostalCodeResponse {
  results: PostalCodeResult[];
  status: 'OK' | 'ZERO_RESULTS' | string;
  postalCode: string;
  countryCode: string;
  city?: string;
  state?: string;
}

export interface ConvertCurrencyRequest {
  from: string;
  to: string;
  amount?: number;
}

export interface ConvertCurrencyResponse {
  convertedAmount: number;
  from: string;
  to: string;
  originalAmount: number;
}
